<script>
import List from "@/components/molecules/list";
import ButtonIcon from "@/components/molecules/button-icon";
import ListItemNavigation from "@/components/molecules/list-item-navigation";
import LazyImage from "@/components/atoms/lazy-image";
import { focusOnElement } from "~/utils/focus";

import pictoAlcoolWeb from "@/assets/images/picto-alcool-web.svg";
import {
  headerMenuLayerEmits,
  headerMenuLayerProps,
  useHeaderMenuLayer
} from "./mixin";

export default {
  name: "MenuLayer",
  components: {
    ListItemNavigation,
    LazyImage,
    List,
    ButtonIcon
  },
  props: {
    ...headerMenuLayerProps()
  },
  emits: [
    "categorySelected",
    "close",
    "displayCategory",
    ...headerMenuLayerEmits()
  ],
  setup(props, context) {
    const {
      categoryRouting,
      previousIndex,
      currentCategory,
      parentCategory,
      isCoinDesMarques,
      reset,
      redirectedToProductList,
      categoryAccessed,
      getPushData,
      menuCodes
    } = useHeaderMenuLayer(props, context);
    return {
      categoryRouting,
      previousIndex,
      currentCategory,
      parentCategory,
      isCoinDesMarques,
      reset,
      redirectedToProductList,
      categoryAccessed,
      getPushData,
      menuCodes,
      pictoAlcoolWeb
    };
  },
  methods: {
    select(category, index) {
      this.previousIndex.push(index);
      this.categoryRouting.push(category);
      this.$nextTick(() => {
        focusOnElement(this.$refs.menuLink[this.$refs.menuLink.length - 1]);
      });
      this.$emit("categorySelected");
    },
    goToPrevious() {
      if (this.categoryRouting.length > 1) {
        const index = this.previousIndex.pop();
        this.categoryRouting.pop();
        this.$nextTick(() => {
          focusOnElement(
            this.$refs.menuLink[this.$refs.menuLink.length - 1 - index]
          );
        });
      } else {
        this.$emit("close");
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      focusOnElement(this.$refs.menuLink[0]);
    });
  },
  updated() {
    this.$emit("displayCategory", this.currentCategory);
  }
};
</script>

<template>
  <div class="c-header-menu-layer-mobile">
    <div class="c-header-menu-layer-mobile__container">
      <ButtonIcon
        class="c-header-menu-layer-mobile__btn-return"
        icon-name="arrow-left"
        icon-color="white"
        icon-position="abs-left"
        icon-size="md"
        variant="primary"
        full-width
        :aria-label="`${currentCategory.attributes.libelle} remonter d'un niveau`"
        @click="goToPrevious"
      >
        {{ currentCategory.attributes.libelle }}
      </ButtonIcon>
      <div
        v-if="currentCategory.attributes.alcool"
        class="u-text-center u-bgcolor-grey-5 u-p-xs"
      >
        <LazyImage
          :src="pictoAlcoolWeb"
          height="50"
          width="113"
        />
      </div>
      <List :aria-label="currentCategory.attributes.libelle">
        <template
          v-for="(child, index) in currentCategory.attributes.children.data"
          :key="child.id"
        >
          <template v-if="!child.attributes.children || child.attributes.children.data.length === 0 || child.attributes.web_behaviour === 'SkipChildren'">
            <ListItemNavigation
              ref="menuLink"
              :image="String(child.attributes.visuel)"
              :image-dimension="200"
              icon-size="sm"
              :no-border="isCoinDesMarques ? false : index == currentCategory.attributes.children.data.length - 1"
              class="u-full-width"
              :to="child.attributes.slug"
              :brand="coinDesMarquesIds.includes(child.id)"
              :show-image="!coinDesMarquesIds.includes(child.id)"
              @click="redirectedToProductList(child)"
            >
              {{ child.attributes.libelle }}
            </ListItemNavigation>
          </template>
          <template v-else>
            <ListItemNavigation
              ref="menuLink"
              :image="String(child.attributes.visuel)"
              :image-dimension="200"
              icon-size="sm"
              class="u-full-width"
              :no-border="isCoinDesMarques ? false : index == currentCategory.attributes.children.data.length - 1"
              :brand="coinDesMarquesIds.includes(child.id)"
              :show-image="!coinDesMarquesIds.includes(child.id)"
              @click="select(child, index)"
            >
              {{ child.attributes.libelle }}
            </ListItemNavigation>
          </template>
          <ListItemNavigation
            v-if="isCoinDesMarques && index == currentCategory.attributes.children.data.length - 1"
            ref="menuLink"
            sub-lvl
            class="u-full-width"
            :to="currentCategory.attributes.slug"
          >
            Découvrir le coin des marques
          </ListItemNavigation>
        </template>
      </List>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/styles/components/header-menu-layer-mobile.scss";
</style>
